<div class="container">
    <ion-slides>
        <ion-slide *ngFor="let slide of length; let activeSlide = index; let isFirst = first;">
            <div class="item" *ngIf="tshirt && isFirst" (click)="onAddEvent()" >
                <div class="circle">
                    <span class="plus-icon">+</span>
                </div>
                <div class="item-text">{{ addText }}</div>
            </div>
            <div class="item" *ngFor="let item of getItems(activeSlide, isFirst); let i = index" (click)="click(item)">
                <div *ngIf="!tshirt" class="circle"
                    [style.background-image]="'url(./assets/lineup/backgrounds/' + item.path + '.png)'">
                </div>
                <div *ngIf="tshirt" class="circle">
                    <svg-tshirt-container [type$]="type.default" [style$]="0" class="tshirt-image"></svg-tshirt-container>
                </div>
                <div class="item-text">{{ item?.name }}</div>
                <div class="item-text no-margin-top" *ngIf="item && item.memo">{{ item?.memo }}</div>
            </div>
        </ion-slide>
        <ion-slide *ngIf="items?.length == 0">
            <div class="item" (click)="onAddEvent()">
                <div class="circle">
                    <span class="plus-icon">+</span>
                </div>
                <div class="item-text">{{ addText }}</div>
            </div>
        </ion-slide>
    </ion-slides>
</div>